import _regeneratorRuntime from "/home/daniel/Proyectos/gcom/frontend/node_modules/@babel/runtime-corejs2/regenerator";
import "regenerator-runtime/runtime";
import _asyncToGenerator from "/home/daniel/Proyectos/gcom/frontend/node_modules/@babel/runtime-corejs2/helpers/asyncToGenerator";
export default /*#__PURE__*/(function () {
  var _ref2 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee(_ref) {
    var router, Vue;
    return _regeneratorRuntime.wrap(function _callee$(_context) {
      while (1) {
        switch (_context.prev = _context.next) {
          case 0:
            router = _ref.router, Vue = _ref.Vue;
            router.afterEach(function (to, from) {
              var canNavigate = to.matched.some(function (route) {
                // Si existe alguna ruta con meta
                if (route.meta.Superadmins || route.meta.Administradores || route.meta.Gestores || route.meta.Miembros) {
                  for (var m in route.meta) {
                    if (Vue.prototype.$ability.can(m)) {
                      return true;
                    }
                  }

                  return false;
                } else {
                  // Si no existe ninguna meta entonces hay acceso para todos.
                  return true;
                }
              });

              if (!canNavigate) {
                Vue.prototype.$q.notify({
                  message: 'No tiene permisos para acceder a esta ruta.',
                  color: 'negative'
                });
                router.push('/');
              } // No hacer nada y continuar

            });

          case 2:
          case "end":
            return _context.stop();
        }
      }
    }, _callee);
  }));

  return function (_x) {
    return _ref2.apply(this, arguments);
  };
})();